import { valibotResolver } from "@hookform/resolvers/valibot";
import { Link as LinkIcon } from "@phosphor-icons/react";
import { useState } from "react";
import { useForm } from "react-hook-form";

import { Button } from "common/components/ui/Button";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogTrigger,
} from "common/components/ui/Dialog";
import {
  Drawer,
  DrawerContent,
  DrawerTitle,
  DrawerTrigger,
} from "common/components/ui/Drawer";
import FormField from "common/components/ui/FormField";
import { Input } from "common/components/ui/Input";
import { HTTPError } from "common/helpers/HTTP";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";

import useTargetingMutations from "../../../../../datahooks/useTargetingMutations";
import { NavigatorUrlSchema } from "../../../../../schemas";

export default function UrlTargeting({ initialUrl }: { initialUrl: string }) {
  const isDesktop = useTwBreakpoint("lg");
  const [isOpen, setIsOpen] = useState(!!initialUrl);
  const { setTargeting, isSettingTargeting } = useTargetingMutations();

  const {
    register,
    formState: { errors },
    setError,
    handleSubmit,
  } = useForm({
    defaultValues: {
      url: initialUrl || "",
    },
    resolver: valibotResolver(NavigatorUrlSchema),
  });

  function onSubmit({ url }: { url: string }) {
    setTargeting({ campaignTargeting: { url } }).catch((err) => {
      if (err instanceof HTTPError && err.data === "InvalidURL") {
        setError("url", { message: "Invalid URL" });
      }
    });
  }

  const Component = isDesktop ? Dialog : Drawer;
  const Content = isDesktop ? DialogContent : DrawerContent;
  const Trigger = isDesktop ? DialogTrigger : DrawerTrigger;
  const Title = isDesktop ? DialogTitle : DrawerTitle;

  return (
    <Component open={isOpen} onOpenChange={setIsOpen}>
      <Trigger asChild>
        <Button size="sm" leftIcon={<LinkIcon />} variant="outline-black">
          Search by URL
        </Button>
      </Trigger>
      <Content>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Title className="mb-8">Paste Sales Navigator Search URL</Title>
          <FormField
            size="lg"
            label="Sales Navigator Search URL"
            htmlFor="navigator-search-url"
            hint="Correct format starts with: 'https://www.linkedin.com/sales/search/people?query=...'"
            className="mb-8"
            error={errors.url?.message}
          >
            <Input
              id="navigator-search-url"
              variant="lg"
              placeholder="Enter URL here"
              {...register("url")}
            />
          </FormField>
          <div className="flex justify-between gap-x-2.5">
            <Button
              className="lg:flex-1"
              variant="secondary-black"
              onClick={() => setIsOpen(false)}
              disabled={isSettingTargeting}
            >
              Cancel
            </Button>

            <Button
              className="lg:flex-1"
              type="submit"
              isLoading={isSettingTargeting}
            >
              Next
            </Button>
          </div>
        </form>
      </Content>
    </Component>
  );
}
